module.exports = __webpack_public_path__ + "img/enterprise_setup_3.c30561f5.svg";